<template>
    <div class="content">
        <div class="container-fluid">
            <p>Dashboard</p>
        </div>
    </div>
</template>